import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useDispatch, useSelector } from "react-redux";
import SearchFilterBox from "../../Components/SearchFilterBox";
import Table from "../../Components/Brokers/Tables";
import { toast } from "react-toastify";
import SideModal from "../../Components/SideModal";
import AddBroker from "../../Components/Brokers/AddBroker";
import EditBroker from "../../Components/Brokers/EditBroker";
import DeleteBroker from "../../Components/Brokers/DeleteBroker";
import { save_Brokers } from "../../Redux/actions";
import ViewInventoriesModel from "../../Components/Common/ViewInventoriesModel";
import { AddBtn } from "../../Components/Styles/InputStyles";


const BrokersList = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
    // { label: "Inventory Name", value: 3 },
  ];

  const dispatch = useDispatch();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showEditBroker, setShowEditBroker] = useState(false);
  const [showAddBroker, setShowAddBroker] = useState(false);
  const [showViewProps, setShowViewProps] = useState(false);
  const [deleteBroker, setDeleteBroker] = useState(false);
  const [inventoryList, setInventoryList] = useState([]);



  const getFilterType = (type) => {
    switch (type) {
      case 1:
        return "MOBILE";
      case 2:
        return "NAME";
      case 3:
        return "INVENTORY_NAME";
      default:
        return "";
    }
  };

  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    const response = await axios.get(
      `${Config.apiUrl}/channelPartner/list?${query}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess) {
      const list = res?.list;
      const formattedList = Array.isArray(list)
        ? list
        : list
        ? [list]
        : [];

      setApiData(formattedList);
      dispatch(save_Brokers(formattedList));
      setIsFocused(true);
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });


  useEffect(() => {
    getListMutate({ searchQuery, filterType });
  }, []);


    const handleFilterChange = (values) => {
    const type = getFilterType(values.filterType);

    setFilterType(type);
    setSearchQuery(values.searchQuery);

    getListMutate({
      searchQuery: values.searchQuery,
      filterType: type,
    });
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };

  const handleCloseEditBroker = () => {
    setShowEditBroker(false);
  };
  const handleCloseAddBroker = () => {
    setShowAddBroker(false);
  };

  const handleCloseViewProps = () => {
    setShowViewProps(false);
  };

  //------- Add Broker details -------
  const addBrokerFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/channelPartner/add`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const addBrokerSuccess = (data) => {
    setShowAddBroker(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const addBrokerError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addBrokerLoading, mutate: addBrokerMutate } =
    useMutation(addBrokerFunction, {
      onSuccess: addBrokerSuccess,
      onError: addBrokerError,
    });

  ///edit
  const editBrokerFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/channelPartner/edit`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const editBrokerSuccess = (data) => {
    setShowEditBroker(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const editBrokerError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editBrokerLoading, mutate: editBrokerMutate } =
    useMutation(editBrokerFunction, {
      onSuccess: editBrokerSuccess,
      onError: editBrokerError,
    });
  //------- Delete Broker -------
  const deleteBrokerFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/channelPartner/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteBrokerSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setDeleteBroker(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteBrokerError = (data) => {
    setDeleteBroker(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteBrokerLoading, mutate: deleteBrokerMutate } =
    useMutation(deleteBrokerFunction, {
      onSuccess: deleteBrokerSuccess,
      onError: deleteBrokerError,
    });


  const handleLocationClose = () => {
    setDeleteBroker(false);
  };


  // ------- Get Inventory List By Inventory Id -------
  const getInventoryListFunction = async (item) => {
    const response = await axios.get(
      `${Config.apiUrl}/inventory/list?&s=${item.id}&t=${Config.USER_TYPE_RETAIL.CHANNEL_PARTNER}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  };

  const getInventoryListSuccess = (res) => {

    if (res?.isSuccess) {
      setInventoryList(res?.data || []);
      setShowViewProps(true);
    }
  };

  const getInventoryListError = (err) => {
    toast.error(err?.response?.data?.msg || "Error fetching Inventory");
  };
  const { mutate: getInventoryListMutate, isLoading: inventoryLoading } =
    useMutation(getInventoryListFunction, {
      onSuccess: getInventoryListSuccess,
      onError: getInventoryListError,
    });


  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Brokers
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          <AddBtn
            type="button"
            onClick={() => {
              setShowAddBroker(true);
            }}
          >
            {"Add Broker"}
          </AddBtn>
        </div>
      </BoxHead>

      <SideModal
        isOpen={showEditBroker}
        onClose={handleCloseEditBroker}
        level="base"
      >
        <EditBroker
          handleClose={handleCloseEditBroker}
          selectedData={selectedData}
          editBrokerMutate={editBrokerMutate}
          editBrokerLoading={editBrokerLoading}
          setShowEditBroker={setShowEditBroker}
        />
      </SideModal>
      <SideModal
        isOpen={showAddBroker}
        onClose={handleCloseAddBroker}
        level="base"
      >
        <AddBroker
          handleClose={handleCloseAddBroker}
          selectedData={selectedData}
          addBrokerMutate={addBrokerMutate}
          addBrokerLoading={addBrokerLoading}
        />
      </SideModal>

      <SideModal
        isOpen={showViewProps}
        onClose={handleCloseViewProps}
        level="base"
      >
        <ViewInventoriesModel
          apiData={inventoryList}
          handleClose={handleCloseViewProps}
          selectedData={selectedData}
        />
      </SideModal>

      <FilterTableWrapper>
        <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {/* Left: Total Amount */}
          <div className="flex items-center">
            <Text>
              Total brokers:{" "}
              <span className="font-semibold">
                {apiData?.length || 0}
              </span>
            </Text>
          </div>

          {/* Right: Search / Filters */}
          <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
            />
          </div>
        </FilterWrapper>

        {deleteBroker && (
          <DeleteBroker
            setDeleteBroker={setDeleteBroker}
            deleteBroker={deleteBroker}
            deleteBrokerLoading={deleteBrokerLoading}
            deleteBrokerMutate={deleteBrokerMutate}
            selectedData={selectedData}
            handleClose={handleLocationClose}
          />
        )}
        {!isLoading && (
          <TableWrapper>
            <Table
              apiData={apiData}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setShowViewProps={setShowViewProps}
              setShowEditBroker={setShowEditBroker}
              setDeleteBroker={setDeleteBroker}
              getInventoryListMutate={getInventoryListMutate}
              inventoryLoading={inventoryLoading}
            />
            {(!apiData || apiData.length === 0) && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
const Text = tw.p`text-gray-500 text-sm font-normal`;

export default BrokersList;

